import React, { useMemo } from 'react';
import {
  ResultsContainer,
  PageMargin,
  ResultsWrapper,
  ResultsPadding,
} from './OffersListContainer.style';
import { GroupedOffers } from '../../utils/groupOffers';
import { FilterOption } from '../../types';
import VehicleOffersList from '../VehicleOffersList/VehicleOffersList';

const DEFAULT_SORTING = ['q/sq', 'a/s', 'etron'];

type OffersListContainerProps = {
  modelFamilyOptions: {
    [key: string]: FilterOption;
  };
  groupedModels: {
    [key: string]: string[];
  };
  offers: GroupedOffers;
  handleSectionRef: (key: string) => (el: HTMLDivElement | null) => void;
  isAnyFilterSelected: boolean;
  isFiltersOpen: boolean;
};

const OffersListContainer: React.FC<OffersListContainerProps> = ({
  modelFamilyOptions,
  groupedModels,
  offers,
  handleSectionRef,
  isAnyFilterSelected,
  isFiltersOpen,
}) => {
  const renderContent = useMemo(() => {
    if (!Object.keys(offers).length) return null;
    const familyGroupKeys = Object.keys(groupedModels);
    const sortedGroupKeys = familyGroupKeys.sort((a, b) => {
      // Get the index of each element in the DEFAULT_SORTING array
      const indexA = DEFAULT_SORTING.indexOf(a);
      const indexB = DEFAULT_SORTING.indexOf(b);

      // Compare the indices
      return indexA - indexB;
    });
    return sortedGroupKeys.map((groupItem) => {
      const subModelObject = offers[groupItem];
      const subModelKeys = Object.keys(subModelObject);
      if (!subModelKeys.length) return null;

      return (
        <div
          ref={handleSectionRef(`${groupItem}-model`)}
          id={`${groupItem}-model`}
          key={`${groupItem}-key`}
          data-testid={`${groupItem}-section`}
        >
          <ResultsPadding>
            {subModelKeys.map((modelFamilyKey) => {
              const offersToRender = subModelObject[modelFamilyKey];
              return (
                <VehicleOffersList
                  offersToRender={offersToRender}
                  modelFamilyKey={modelFamilyKey}
                  modelFamilyOptions={modelFamilyOptions}
                  key={modelFamilyKey}
                  isAnyFilterSelected={isAnyFilterSelected}
                  isFiltersOpen={isFiltersOpen}
                />
              );
            })}
          </ResultsPadding>
        </div>
      );
    });
  }, [
    groupedModels,
    handleSectionRef,
    isAnyFilterSelected,
    isFiltersOpen,
    modelFamilyOptions,
    offers,
  ]);

  return (
    <>
      <ResultsContainer>
        <PageMargin>
          <ResultsWrapper className="results-wrapper" data-testid="results-wrapper">
            {renderContent}
          </ResultsWrapper>
        </PageMargin>
      </ResultsContainer>
    </>
  );
};

export default OffersListContainer;
